import { getSnowplowEventPayload, logAnalyticsEvent } from 'Services/analytics/analytics';
import { ANALYTICS_CATEGORIES, SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';

const { ACCOUNT } = ANALYTICS_CATEGORIES;
const { CLICK } = SNOWPLOW_EVENTS;

export const triggerSellerMessagingMarkAsContactedCancelButtonClickedEvent = (): void => {
	const eventPayload = getSnowplowEventPayload({
		category: ACCOUNT.SELLER_MESSAGING,
		name: 'dlr_seller_messaging_mark_as_contacted_cancel_button_clicked',
		schemaName: CLICK.SCHEMA,
		version: CLICK.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
